import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import ham from "./Header/hamburgerMenu.svg";
import courseMenus from "./courseNavigation";

function MobileCourseLink({ item, closeMenu }) {
  if (item.href) {
    return (
      <a
        className="HamDD"
        href={item.href}
        target="_blank"
        rel="noreferrer noopener"
        onClick={closeMenu}
      >
        {item.label}
      </a>
    );
  }

  return (
    <Link className="HamDD" to={item.to} onClick={closeMenu}>
      {item.label}
    </Link>
  );
}

function Navbar() {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (!showMenu) return;

      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  const toggleMenu = () => {
    setShowMenu((prev) => !prev);
  };

  const closeMenu = () => {
    if (showMenu) {
      setShowMenu(false);
    }
  };

  return (
    <div className="nav navbarHam">
      <div
        className="dropDownInner"
        style={{ position: "relative" }}
        ref={menuRef}
      >
        <button
          type="button"
          className="hamburgerMenu"
          style={{
            color: "white",
            textDecoration: "none",
            marginRight: "1em",
            background: "#333",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
          onClick={toggleMenu}
          aria-label={showMenu ? "Close menu" : "Open menu"}
          aria-expanded={showMenu}
          aria-haspopup="true"
        >
          <img src={ham} alt="" />
        </button>

        {showMenu && (
          <div
            style={{
              textAlign: "left",
              width: "100vw",
              height: "100vh",
              left: "-1em",
              position: "absolute",
              background: "rgb(0,0,0,80%)",
              color: "white",
              padding: "10px",
              overflow: "scroll",
              paddingBottom: "20vh",
            }}
          >
            {courseMenus.map((menu) => (
              <React.Fragment key={menu.id}>
                <p className="navSeparator">
                  <strong>{menu.label} ↓</strong>
                </p>

                {menu.sections.map((section) => (
                  <React.Fragment key={section.label}>
                    <p style={{ margin: "1em 0 .25em" }}>
                      <strong>{section.label}</strong>
                    </p>

                    {section.links.map((item) => (
                      <MobileCourseLink
                        key={item.to || item.href}
                        item={item}
                        closeMenu={closeMenu}
                      />
                    ))}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ))}

            <p className="navSeparator">
              <strong>School ↓</strong>
            </p>

                <Link
                  onClick={closeMenu}
                  to="/events/ai-agent-workshop-barcelona/"
                  className="HamDD"
                >
                  Events
                </Link>

            <Link
              className="HamDD"
              to="/about-us/testimonials/"
              onClick={closeMenu}
            >
              Testimonials
            </Link>

            <Link
              className="HamDD"
              to="/about-us/instructors/"
              onClick={closeMenu}
            >
              Instructors
            </Link>

            <Link
              className="HamDD"
              to="/about-us/career-services/"
              onClick={closeMenu}
            >
              Career services
            </Link>

            <Link className="HamDD" to="/about-us/school/" onClick={closeMenu}>
              About us
            </Link>

            <Link className="HamDD" to="/blog/" onClick={closeMenu}>
              Blog
            </Link>

            <Link className="HamDD" to="/lab/" onClick={closeMenu}>
              BCS Lab
            </Link>

            <Link className="HamDD" to="/contacts/" onClick={closeMenu}>
              Contact us
            </Link>

            <p className="navSeparator">
              <strong>For companies ↓</strong>
            </p>

            <Link
              className="HamDD"
              to="/ai-implementation-in-barcelona-code-school/"
              onClick={closeMenu}
            >
              AI implementation
            </Link>

            <Link
              className="HamDD"
              to="/corporate-training/"
              onClick={closeMenu}
            >
              Training and development
            </Link>

            <Link
              className="HamDD"
              to="/job-offer/"
              onClick={closeMenu}
              style={{ marginBottom: "3em" }}
            >
              Hire graduates
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
